// ------ kiyoh logo image remove ----------
window.addEventListener('load', function() {
  console.log('massi de gaci---', window);
  document.getElementById('window_load_image').style.display = 'none';
});


document.addEventListener("DOMContentLoaded",function() {
  // ================ Update Cart ===================== //

  let AddToCartBtn = document.querySelectorAll('form[action="/cart/add"]');
  AddToCartBtn?.forEach((form) => {
    form.addEventListener('submit',async function(event) {
      event.preventDefault();
       
      // Submit Form With Ajax
      await fetch("/cart/add",{
        method: "post",
        body: new FormData(form),
      });

      // Get new cart object
      const res=await fetch("/cart.json");
      const cart=await res.json();

      document.querySelectorAll('.cart-link__bubble ').forEach((e) => {
        e.textContent=cart.item_count;
      })

    })
  })

  // =============  Quantity Selector Update Cart  ================== //

  document.addEventListener("DOMContentLoaded",function() {
    document.body.addEventListener('click',function(e) {
      if(e.target.classList.contains('ctm_input_val')||e.target.closest('.js-qty__wrapper')) {

        let cartItem=e.target.closest('.cart__item')
        let varId=cartItem.querySelector('[data-variant-id]').getAttribute('data-variant-id');
        let varQty=cartItem.querySelector('[data-variant-id]').value;

        // console.log(varId, varQty);
        const updatedData={
          id: varId,
          quantity: varQty
        };
        updateCart(updatedData);

      }
    })
  });

  function updateCart(updatedData) {
    fetch('/cart/change.js',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updatedData)
    })
      .then(response => {
        if(response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to update cart');
        }
      })
      .then(data => {
        // console.log('Cart count:',data.item_count);
        document.querySelectorAll('.cart-link__bubble').forEach((e) => {
          e.textContent=data.item_count;
        })
      })
      .catch(error => {
        console.error('Error:',error);
      });
  }
  //  ================ Resent Blog Post Store In Local Storage  ===============

  let mainBlogDiv = document.querySelector('.ctm_Blog_main_wrapper');
  let recentArticles = JSON.parse(localStorage.getItem('recentArticles')) || [];

  function viewedArticle(articleTitle,articleId,articleUrl) {
    recentArticles = recentArticles.filter(article => article.id !== articleId);
    recentArticles.unshift({title: articleTitle,id: articleId, url: articleUrl });
    if(recentArticles.length > 8) {
      recentArticles.pop();
    }
    localStorage.setItem('recentArticles',JSON.stringify(recentArticles));
    updateRecentArticles();
  }

  window.onload = updateRecentArticles();

  function updateRecentArticles() {
    const recentArticlesList = document.getElementById('recent-articles-list');
    if (recentArticlesList) {
        recentArticlesList.innerHTML = '';
  
      recentArticles.forEach(article => {
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.href = `${article.url}`;
        link.textContent = article.title;
        listItem.appendChild(link);
        recentArticlesList.appendChild(listItem);
      });
    }
    
  }

  mainBlogDiv?.addEventListener('click',function(evt) {
    // evt.preventDefault();
    let blogItem = evt.target.closest('.ctm_blog_post_item');
    if(blogItem) {
      const articleTitle = blogItem.dataset.articleTitle;
      const articleId = blogItem.dataset.articleId;
      const articleUrl = blogItem.dataset.articleUrl;
      viewedArticle(articleTitle,articleId,articleUrl);
    }
  });

})

let filter_button = document.getElementById('filter_header');
filter_button?.addEventListener('click', function(){
  document.getElementById('BlogTagFilter').classList.toggle('blog_filter_animation');
  document.querySelector('#filter_header svg').classList.toggle('blog_open');
});


// ============== footer menu dropdown hover open js code ===========
// let navvv_dropdown = document.querySelectorAll(".site-footer .footer__collapsible .site-nav__details");

// navvv_dropdown.forEach((e) => {
//   e.addEventListener('mouseover', (event) => {
//     e.setAttribute("open", "");
//   });

//   e.addEventListener('mouseout', (event) => {
//     e.removeAttribute("open");
//   });
// });



document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e)=> {

    if (e.target.classList.contains('ctm_foot_dropdown') || e.target.closest('.ctm_foot_dropdown') ) {
      console.log("true");

      let parent = e.target.classList.contains('ctm_foot_dropdown') || e.target.closest('.ctm_foot_dropdown');
      let container = parent.closest('.collapsible-content');
      // let containerHeight = container.clientHeight;      
      // let height = parent.querySelector('ul.site-nav__dropdown').clientHeight;
      let  height = 135;
      let containerHeight = 67;

      // container.style.height = (containerHeight - height) + 'px';
      if (parent.getAttribute('open') != null ) { container.style.height = containerHeight + 'px'; }
      else{ container.style.height = containerHeight + height + 'px'; }
      console.log('ABCC');
      
      
    }
    
  });
})

///////////// Drawer language selector ////////////////// 
let drawer_selector = document.querySelector('#NavDrawer .disclosure__toggle');
drawer_selector.addEventListener('click', () => { drawer_selector.nextElementSibling.classList.toggle('disclosure-list--visible'); });
document.addEventListener("click", (e) =>{

  if (!e.target.id && !e.target.closest('.disclosure.cst_show_mobile')) {
    if(drawer_selector.nextElementSibling.classList.contains('disclosure-list--visible')){
      drawer_selector.nextElementSibling.classList.remove('disclosure-list--visible')
    }
  }

  if( e.target.classList.contains('disclosure-list__item') || e.target.closest('.disclosure-list__item')){
    let item = e.target.classList.contains('disclosure-list__item') || e.target.closest('.disclosure-list__item');
    let val = item.querySelector('a').getAttribute('data-value');
    let input = item.closest('.disclosure').querySelector('#LocaleSelector-drawer-menu');
    let form = item.closest('form');
    input.value = val;
    form.submit();
  }
  
});

